export const REACTION_USER_LIST_DIALOG_MAX_RESULTS = '20';
export const REACTION_USER_LIST_MENU_MIN_RESULTS = '5';
